import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAppContext } from 'components/Context/AppContext';
import { getDetailDriver, getDetailDriverTask } from 'features/drivers/actions';
import { getCustomerData } from 'features/user/slice';
import { fetchOrderById, getOrderAddOnsById } from 'features/orders/actions';
import { fetchCustomerInfo } from 'features/user/actions';
import { checkEmptyObject } from 'utils/functionality';
import WithoutDriverTask from './withoutDriverTask';
import WithDriverTask from './withDriverTask';
import PreviewImage from 'components/Modals/PreviewImage';
import { ReactComponent as LeftArrow } from 'icons/left-arrow.svg';
import { Button } from 'components/Global';
import AirportTransferSingaporeTask from './airportTransferSingaporeTask';
import CarCharterTask from './CarCharterDetailTask';
import countryCodes from 'utils/country-codes.json';

const DetailDriverTask = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const key = searchParams.get('key');
  const customerId = searchParams.get('customer_id');
  const id = searchParams.get('id');

  const { data, status } = useSelector((state) => state.detailOrder);
  const customer = useSelector(getCustomerData);
  const { selected: selectedDriverTaskData } = useSelector((state) => state.driverTaskList);
  const findCountryByCode = (code) => countryCodes.find((item) => item.dial_code == code);

  const { setShowSpinner, setShowBroadcastTaskCharter } = useAppContext();

  const [showImage, setShowImage] = useState({ show: false, image: '' });
  const [selectedCountry, setSelectedCountry] = useState({
    name: '',
    code: '',
  });

  const backHandler = () => {
    navigate(-1);
  };

  useEffect(() => {
    dispatch(fetchOrderById(key));
    dispatch(getDetailDriverTask(id));
    dispatch(getOrderAddOnsById(key));

    if (customerId) {
      dispatch(fetchCustomerInfo(customerId));
    }
  }, []);

  useEffect(() => {
    if (
      !selectedDriverTaskData ||
      checkEmptyObject(selectedDriverTaskData) ||
      selectedDriverTaskData.status === 'OPEN' ||
      !selectedDriverTaskData.driver_id
    )
      return;

    dispatch(getDetailDriver(selectedDriverTaskData.driver_id));
  }, [selectedDriverTaskData]);

  useEffect(() => {
    if (status === 'loading') {
      setShowSpinner(true);
    } else {
      setShowSpinner(false);
    }
  }, [status]);

  useEffect(() => {
    if (customer) {
      setSelectedCountry(findCountryByCode(data?.is_admin_creation ? data?.phone_country_code : customer?.phone_code));
    }
  }, [customer, data]);

  return (
    <>
      <div className="detail-driver-task">
        <header className="detail-driver-task__header" onClick={backHandler}>
          <LeftArrow />
          <p>Kembali</p>
        </header>

        {data?.order_type_id == '8' && !selectedDriverTaskData && checkEmptyObject(selectedDriverTaskData) && (
          <Button
            className="detail-order-airport__publish-btn"
            style={{
              backgroundColor: '#007A05',
            }}
            onClick={() => setShowBroadcastTaskCharter(true)}
            disabled={false}
          >
            Publish Task to Driver
          </Button>
        )}

        {data?.order_detail?.without_driver ? (
          <WithoutDriverTask
            data={data}
            customer={customer}
            setShowImage={setShowImage}
            selectedDriverTaskData={selectedDriverTaskData}
          />
        ) : data?.order_type_id == '2' ||
          data?.order_type_id == '4' ||
          data?.order_type_id == '5' ||
          data?.order_type_id == '6' ? (
          <WithoutDriverTask
            data={data}
            customer={customer}
            setShowImage={setShowImage}
            selectedDriverTaskData={selectedDriverTaskData}
            airportTransfer={data?.order_type_id == 2}
            oneWay={data?.order_type_id == 5 || data?.order_type_id == 6}
          />
        ) : data?.order_type_id == '7' ? (
          <AirportTransferSingaporeTask
            data={data}
            customer={customer}
            setShowImage={setShowImage}
            selectedDriverTaskData={selectedDriverTaskData}
          />
        ) : data?.order_type_id == '8' ? (
          <CarCharterTask
            data={data}
            customer={customer}
            selectedDriverTaskData={selectedDriverTaskData}
            setShowImage={setShowImage}
            selectedCountry={selectedCountry}
            transactionKey={key}
          />
        ) : (
          <WithDriverTask
            data={data}
            customer={customer}
            setShowImage={setShowImage}
            selectedDriverTaskData={selectedDriverTaskData}
          />
        )}

        {data?.order_type_id == '7' || data?.order_type_id == '8' ? null : (
          <div className="action-btn">
            <Button variant="outline" onClick={backHandler} width={192}>
              Kembali
            </Button>
          </div>
        )}
      </div>

      {showImage.show &&
        ReactDOM.createPortal(
          <PreviewImage image={showImage.image} setShow={() => setShowImage(false)} />,
          document.getElementById('modal'),
        )}
    </>
  );
};

export default DetailDriverTask;
